/**
 * LoginPage – leitet sofort zu Auth0 Universal Login weiter.
 * Das alte Email/Passwort-Formular entfällt, da jetzt Auth0 verwendet wird.
 */
import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuth } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";

export default function LoginPage() {
  const { loginWithRedirect, isLoading: auth0Loading, isAuthenticated } = useAuth0();
  const { user } = useAuth();
  const { settings } = useSettings();

  useEffect(() => {
    // Nur zu Auth0 weiterleiten, wenn Auth0 definitiv NICHT authentifiziert ist
    if (!auth0Loading && user === null && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: "/admin/dashboard" },
      });
    }
  }, [auth0Loading, user, isAuthenticated, loginWithRedirect]);

  // Noch am Laden (AuthContext synchronisiert noch)
  if (auth0Loading || user === undefined) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="text-center">
          {settings?.logo_url ? (
            <img src={settings.logo_url} alt={settings.site_name || "HUWND"} className="h-10 w-auto mx-auto mb-6" />
          ) : (
            <div className="w-12 h-12 bg-rose-600 rounded-lg flex items-center justify-center mx-auto mb-6">
              <span className="text-white font-black text-xl font-heading">H</span>
            </div>
          )}
          <div className="w-8 h-8 border-2 border-rose-600 border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-zinc-500 text-sm mt-4">Lade...</p>
        </div>
      </div>
    );
  }

  // Bereits eingeloggt
  if (user) {
    if (user.role === "developer" || user.role === "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        {settings?.logo_url ? (
          <img src={settings.logo_url} alt={settings.site_name || "HUWND"} className="h-10 w-auto mx-auto mb-6" />
        ) : (
          <div className="w-12 h-12 bg-rose-600 rounded-lg flex items-center justify-center mx-auto mb-6">
            <span className="text-white font-black text-xl font-heading">H</span>
          </div>
        )}
        <div className="w-8 h-8 border-2 border-rose-600 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-zinc-500 text-sm mt-4">Weiterleitung zu Auth0...</p>
      </div>
    </div>
  );
}
